import { Slider } from "components/common"
import SkeletonLink from "components/common/skeleton-link"
import image, { CATEGORY_TREASURE } from "lacinetek-common/src/images"
import { useTranslation } from "lib/i18n/translation"
import { get, replace } from "lib/redirects"
import Image from "components/common/image"

const Slide = ({ loading, treasure, corp }) => {
	const target = "/treasures/[id]/[collection]"
	const realTarget = get(target)

	return (
		<SkeletonLink href={target} as={replace(realTarget, treasure.linkRewrite, corp.linkRewrite)}>
			<a title={corp.name} className="slide-content">
				<div className={`infos ${loading ? "skeleton" : ""}`}>
					<h3>{corp.name}</h3>
				</div>
				<figure className={loading ? "skeleton" : ""}>
					<picture>
						<Image src={image(corp, CATEGORY_TREASURE)} className="cover" alt={corp.name} />
					</picture>
				</figure>
			</a>
		</SkeletonLink>
	)
}

export default ({ treasure, other, corpus, loading, current }) => {
	const { c } = useTranslation("common")

	let selectedCorpus = corpus
	if (current) {
		selectedCorpus = selectedCorpus.filter(c => c.id !== current)
	}

	if (selectedCorpus.length == 0) {
		return null
	}

	return (
		<section>
			<h2 className={`section-title icon-chair${loading ? " skeleton" : ""}`}>
				{other ? c("other-collections-of") : c("collections-proposed-by")}
				{" "}
				<strong className={loading ? "skeleton" : ""}>
					{treasure.name}
				</strong>
			</h2>
			<Slider
				slides={selectedCorpus}
				slideComponent={Slide}
				slidePropKey="corp"
				slideRelatedProps={{
					treasure
				}}
				loading={loading}
				className="min"
				hidePagination
			/>
		</section>
	)
}
